import script from "./IGMoments.vue?vue&type=script&setup=true&lang=js"
export * from "./IGMoments.vue?vue&type=script&setup=true&lang=js"

import "./IGMoments.vue?vue&type=style&index=0&id=846b451c&lang=css"

const __exports__ = script;

export default __exports__